{
  "version": 1,
  "asset_id": "1b4a36e2-a4c1-4d18-8e66-9b1cc1b04b5f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/1b4a36e2-a4c1-4d18-8e66-9b1cc1b04b5f/hero-1280.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/1b4a36e2-a4c1-4d18-8e66-9b1cc1b04b5f/hero-1280.webp",
  "original_filename": "hero-1280.webp",
  "size": 28862,
  "content_type": "image/webp",
  "created_at": "2026-06-14T01:11:49Z"
}
